import { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Box, Grid } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch, useSelector } from "react-redux";
import { routeActions } from "../../../store/slices/routeSlice";
import DeleteIcon from "@mui/icons-material/Delete";
import PassengerDeletionConfirmationModal from "../../shared/modals/PassengerDeletionConfirmationModal";
import ConfirmationModal from "../../shared/modals/ConfirmationModal";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import FontDownloadOffIcon from "@mui/icons-material/FontDownloadOff";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import WorkIcon from "@mui/icons-material/Work";
import AirlineSeatLegroomExtraIcon from "@mui/icons-material/AirlineSeatLegroomExtra";
import { routeGroupActions } from "../../../store/slices/routeGroupSlice";
import { Clear, PhoneInTalk } from "@mui/icons-material";
import { Trash } from "lucide-react";

const RouteItemAccordion = ({
  index,
  id,
  color,
  routeId,
  numberOfAdultPassengers,
  numberOfChildPassengers,
  preDepartureTime,
  departureTime,
  postDepartureTime,
  passengerNames,
  address,
  flight,
  phoneNumber,
  contactType,
  passengers,
  note,
  isMarker,
  travelType,
  flightTime,
  addressAddress,
  driverNote,
  hasLuggage,
  hasNotification,
  greenPhone,
  hasQuestionmark,
  isInactive,
  wholeCar,
  wholeBus,
  hasSeats,
  sendPhoneNumber,
  markersCount,
  preDeparture,
  isSent,
  refetch,
  postDeparture,
  routeGroupId,
  onDeletedMarkerSuccessfully: onDeletedMarkerSuccessfullyProp,
}) => {
  useEffect(() => {}, [passengers]);
  const [checkReservationDeletion, setCheckReservationDeletion] =
    useState(false);
  const {
    softDeleteRouteReturnReservationFlag,
    softDeleteRouteReturnReservation,
  } = useSelector((state) => state.route);

  const { createGroupEditor, selectedRoutesIds } = useSelector(
    (state) => state.routeGroup
  );

  const dispatch = useDispatch();

  const editRouteHandler = () => {
    dispatch(routeActions.getRoutesByRouteIdFetch(routeId));
    dispatch(routeActions.toggleRouteModal());
  };

  const deleteMarkerHandler = () => {
    dispatch(routeActions.deleteMarker({ id, onDeletedMarkerSuccessfully }));
  };

  const onDeletedMarkerSuccessfully = () => {
    onDeletedMarkerSuccessfullyProp();
  };

  const checkDeleteRouteHandler = () => {
    setCheckReservationDeletion(true);
  };

  const onSuccessfulySoftDeleteReturnRoute = (sentId) => {
    if (sentId !== null) {
      dispatch(routeActions.resetSoftDeleteRouteReturnReservationId());
    }
  };

  const deleteRouteFromRouteGroupHandler = () => {
    dispatch(
      routeGroupActions.deleteRouteFromRouteGroupPut({
        routeId: id,
        id: routeGroupId,
        onSucceededDeletedRouteFromRouteGroup: refetch,
      })
    );
  };

  const deleteRouteHandler = (sentId = null) => {
    dispatch(
      routeActions.softDeleteRouteFetch({
        id: sentId ? sentId : id,
        onSuccessfulySoftDeleteRoute: onDeletedMarkerSuccessfullyProp,
        onSuccessfulySoftDeleteReturnRoute: () => {
          onSuccessfulySoftDeleteReturnRoute(sentId);
        },
      })
    );
  };

  const toggleGroupEditingCheckbox = () => {
    dispatch(routeGroupActions.insertRemoveRouteToRoutesIds(id));
  };

  return (
    <>
      <ConfirmationModal
        title="Želite da obrisete rezervaciju?"
        open={checkReservationDeletion}
        onAccept={() => {
          deleteRouteHandler();
        }}
        onClose={() => {
          setCheckReservationDeletion(false);
        }}
      />
      {softDeleteRouteReturnReservation && (
        <PassengerDeletionConfirmationModal
          title="Želite da obrisete povratnu rezervaciju?"
          open={softDeleteRouteReturnReservationFlag ?? false}
          onAccept={() => {
            deleteRouteHandler(softDeleteRouteReturnReservation.id);
          }}
          onClose={() => {
            dispatch(routeActions.resetSoftDeleteRouteReturnReservationId());
          }}
          name={softDeleteRouteReturnReservation.name}
          date={softDeleteRouteReturnReservation.date}
          passengersNumber={softDeleteRouteReturnReservation.passengersNumber}
          relationFrom={softDeleteRouteReturnReservation.relationFrom}
          relationTo={softDeleteRouteReturnReservation.relationTo}
        />
      )}
      <div>
        {isMarker && (
          <div className="marker">
            {(() => {
              const marker = markersCount?.find((x) => x.id === id);
              if (!marker)
                return <p style={{ color: "white", fontWeight: "bold" }}>0</p>;

              return (
                <div className="d-flex gap-4 marker-value">
                  <p style={{ fontWeight: "bold" }}>Ukupno: {marker.count}</p>
                  <p style={{ fontWeight: "bold" }}>
                    Aktivnih: {marker.hasNotificationCount}
                  </p>
                  <p style={{ fontWeight: "bold" }}>
                    Neaktivnih: {marker.isInactiveCount}
                  </p>
                  <p style={{ fontWeight: "bold" }}>
                    Upitnih: {marker.hasQuestionmarkCount}
                  </p>
                </div>
              );
            })()}
            <button onClick={deleteMarkerHandler}>
              <Trash size={16} color="rgb(92, 86, 86)" />
            </button>
          </div>
        )}
        {!isMarker && (
          <Accordion
            sx={{
              m: 0,
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ArrowDropDownIcon sx={{ display: "none" }} />}
              aria-controls="panel2-content"
              id="panel2-header"
              sx={{
                padding: 0,
                minHeight: "60px",
                paddingTop: "7px",
                // backgroundColor: routeGroupId && "white ",
                backgroundColor: isSent ? "#3acf3a83" : "white",

                "& .MuiAccordionSummary-content": {
                  margin: 0,
                },
                "&.Mui-expanded": {
                  minHeight: "unset",
                },
              }}
            >
              {createGroupEditor && (
                <div className="h-[inherit] me-2 d-flex items-center">
                  <input
                    className="relative z-[99999]"
                    type="checkbox"
                    checked={
                      (routeGroupId && routeGroupId > 0) ||
                      selectedRoutesIds.includes(id)
                    }
                    onChange={toggleGroupEditingCheckbox}
                    disabled={routeGroupId && routeGroupId > 0}
                    onClick={(e) => e.stopPropagation()}
                    onFocus={(e) => e.stopPropagation()}
                  />
                </div>
              )}
              <div className="w-100 display-flex flex-column">
                <div
                  className={`route-item-accordion-header-card ${isInactive ? "inactive-card" : ""}`}
                  style={{
                    opacity: isInactive ? 0.7 : 1,
                    backgroundColor: isSent ? "transparent" : "white",
                  }}
                >
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns:
                        "40px 40px 1.5fr 1.5fr 2fr 1.5fr 40px",
                      alignItems: "center",
                      width: "100%",
                      borderBottom: "1px solid #eee",
                      paddingX: "8px",
                      minHeight: "52px",
                      gap: "10px",
                       "&:hover": { opacity: 0.5 },
                    }}
                  >
                    <Typography
                      component="span"
                      className="route-item-time"
                      sx={{
                        fontSize: "14px",
                      }}
                    >
                      {preDepartureTime && `${preDepartureTime}-`}
                      {departureTime}
                      {postDepartureTime && `-${postDepartureTime}`}
                    </Typography>

                    <Typography
                      component="span"
                      className="route-item-bold"
                      sx={{
                        fontSize: "14px",
                      }}
                    >
                      {numberOfAdultPassengers}
                      {numberOfChildPassengers > 0 &&
                        `+${numberOfChildPassengers}`}
                    </Typography>
                    <Typography
                      component="span"
                      className="route-item-bold"
                      sx={{
                        fontSize: "14px",
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                        textOverflow: "ellipsis",
                        whiteSpace: "normal",
                      }}
                    >
                      {passengerNames}
                    </Typography>

                    <Typography
                      component="span"
                      className="route-item-bold"
                      sx={{
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                        textOverflow: "ellipsis",
                        whiteSpace: "normal",
                        fontSize: "14px",
                      }}
                    >
                      {preDeparture} {postDeparture} {address}
                    </Typography>

                    <div className="route-item-info">
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                        flexWrap="wrap"
                        sx={{
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 2,
                          textOverflow: "ellipsis",
                          whiteSpace: "normal",
                        }}
                      >
                        {travelType !== 0 && (
                          <Typography
                            component="span"
                            className="route-item-bold"
                            sx={{
                              fontSize: "14px",
                            }}
                          >
                            {travelType === 1 ? "Let" : "Adresa"}
                          </Typography>
                        )}
                        {flightTime && (
                          <Typography
                            component="span"
                            className="route-item-bold"
                            flexWrap="wrap"
                            sx={{
                              fontSize: "14px",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                            }}
                          >
                            {flightTime}
                          </Typography>
                        )}
                        {addressAddress && (
                          <Typography
                            component="span"
                            className="route-item-bold"
                            sx={{
                              fontSize: "14px",
                            }}
                          >
                            {addressAddress}
                          </Typography>
                        )}
                      </Box>

                      <div className="route-item-icons">
                        {hasLuggage && <WorkIcon />}
                        {sendPhoneNumber && <LocalPhoneIcon />}
                        {hasNotification && <NotificationsActiveIcon />}
                        {hasQuestionmark && <QuestionMarkIcon />}
                        {isInactive && <FontDownloadOffIcon />}
                        {wholeBus && <DirectionsBusIcon />}
                        {wholeCar && <DirectionsCarIcon />}
                        {hasSeats && <AirlineSeatLegroomExtraIcon />}
                        {greenPhone && <PhoneInTalk sx={{ color: "green" }} />}
                      </div>
                    </div>

                    <Typography
                      component="span"
                      className="route-item-bold"
                      sx={{
                        fontSize: "14px",
                      }}
                    >
                      {phoneNumber} {contactType}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {routeGroupId && !isSent && (
                        <Clear
                          fontSize="small"
                          sx={{ color: "black", cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteRouteFromRouteGroupHandler();
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className="route-item-accordion-content position-relative">
                {passengers &&
                  passengers.length > 0 &&
                  passengers.map((passenger, index) => (
                    <Grid container spacing={2} key={index}>
                      <Grid item lg={3} md={3} xs={6}>
                        <div className="full-display-flex">
                          {passenger.fullName}
                          {passenger.ageType > 1 && <p>(Dete)</p>}
                        </div>
                      </Grid>
                      <Grid item lg={3} md={3} xs={6}>
                        {passenger.phoneNumber}
                      </Grid>
                      <Grid item lg={6} md={6} xs={6}>
                        {passenger.address}
                      </Grid>
                    </Grid>
                  ))}

                {!routeGroupId && (
                  <div className="edit-route-item-accordion-button">
                    <EditIcon
                      sx={{ cursor: "pointer" }}
                      onClick={editRouteHandler}
                    />
                    <DeleteIcon
                      sx={{ cursor: "pointer", color: "red" }}
                      onClick={checkDeleteRouteHandler}
                    />
                  </div>
                )}
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography
                    component="span"
                    sx={{ fontWeight: "bold", marginTop: "1rem" }}
                  >
                    NAPOMENA ZA VOZAČA: {driverNote}
                  </Typography>

                  <Typography
                    component="span"
                    sx={{ fontWeight: "bold", marginTop: "0.5rem" }}
                  >
                    NAPOMENA: {note}
                  </Typography>
                </Box>
              </div>
            </AccordionDetails>
          </Accordion>
        )}
      </div>
    </>
  );
};

export default RouteItemAccordion;
